import { Autocomplete, Box, Button, Chip, MenuItem, TextField, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import i18n from '../../i18n';
import { CancelSharp } from '@mui/icons-material';

/**
 * 多重选择组件
 * @param props
 * @returns
 */
export default function SelectInputMultiple(props: SelectInputMultipleProps) {
    const { label, options, onChange, value, fullSelect, limitTagsNum } = props;
    // 下拉框选择的值
    const onSelectChange = (value: Option[]) => {
        if (onChange && typeof onChange === 'function') onChange(value);
    }
    return (
        <Box sx={{ display: 'flex' }} className={props.className}>
            <Autocomplete
                // 为 true 时首项常带 Mui-focused，与 :hover 紫底叠加会「双紫」；默认关
                autoHighlight={props.autoHighlight ?? false}
                id='autocomplete-select'
                size='small'
                // clearOnBlur
                fullWidth
                value={value}
                openOnFocus
                // inputValue={''}
                noOptionsText={i18n.t('general_text_no_data')}
                onChange={(event, value) => {
                    onSelectChange(value);
                }}
                options={options}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                multiple
                limitTags={limitTagsNum ?? 4}
                ChipProps={{
                    variant: 'outlined',
                    color: 'primary',
                }}
                filterSelectedOptions
                disableCloseOnSelect
                getOptionLabel={option => option.label}
                renderOption={(props, option, state) => (
                    <MenuItem
                        {...props}
                        key={option.value}
                        value={option.value}
                        selected={state.selected}
                    >
                        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            {
                                option?.icon &&
                                <div style={{ marginTop: 5 }}>
                                    {option.icon}
                                </div>
                            }
                            <Typography
                                variant='inherit'
                                sx={{ marginLeft: 5, color: 'inherit' }}
                            >
                                {option.label}
                            </Typography>
                        </Box>
                    </MenuItem>
                )}
                renderInput={params => {
                    return (
                        <Box
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            style={{ position: 'relative' }}
                        >
                            <TextField
                                {...params}
                                variant='outlined'
                                label={typeof label === 'string' ? i18n.t(label as string) : label}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{ minWidth: 200 }}
                                autoComplete='off'
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                placeholder={props.placeholder}
                            />
                            {fullSelect &&
                                <Button
                                    sx={{
                                        position: 'absolute', right: 60
                                    }}
                
                                    onClick={(event) => {
                                        event.stopPropagation()
                                        onSelectChange?.(options)
                                    }}
                                >
                                    {i18n.t('menu_dish_maker_page_text_select_all')}
                                </Button>
                            }
                        </Box>
                    )
                }}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((item, index) => {
                        const { label, icon } = item;
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <Chip
                                avatar={icon}
                                label={label}
                                size={'medium'}
                                sx={(theme) => {
                                    return {
                                        '.MuiChip-deleteIcon': {
                                            color: theme.palette.primary.light,
                                            '&:hover': {
                                                color: theme.palette.primary.main
                                            }
                                        }
                                    }
                                }}
                                style={{
                                    color: 'var(--text-dark)',
                                    backgroundColor: 'var(--icon-primary-200)',
                                    borderColor: 'var(--icon-primary-300)',
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }}
                                deleteIcon={(<CancelSharp />)}
                                variant='outlined'
                                {...getTagProps({ index })}
                            />
                        );
                    })
                }
                disabled={props.disabled}
            />
        </Box >

    )
}

export type Option = {
    label: string;
    value: string;
    icon?: JSX.Element;
}
export type SelectInputMultipleProps = {
    placeholder?: string;
    // 多选框数组
    options: Option[];
    // 输入框标签
    label?: string | ReactNode;
    // 输入框最多显示的标签数
    limitTagsNum?: number;
    onChange?: ((option: Option[]) => void);
    fullSelect?: boolean;
    value?: Option[];
    // 禁用
    disabled?: boolean;
    className?: string;
    /** 默认 false，避免首项 focused 与悬停项同时紫底高亮 */
    autoHighlight?: boolean;
}
